import PropTypes from 'prop-types';

import {
    BLACK_KEY, BLUE_KEY, M_KEY
} from 'Component/Icon/Icon.config';
import InfoIcon from 'Component/InfoIcon';
import RulerIcon from 'Component/RulerIcon';

import {
    BANNER,
    BANNER_INFO,
    LARGE, SMALL
} from './NoticeBanner.config';
/** @namespace Bodypwa/Component/NoticeBanner/Component/NoticeBanner */
export function NoticeBanner({
    icon = null,
    text = '',
    type = BANNER_INFO,
    size = SMALL,
    children = null,
    isHideIcon = false,
    iconSize = null
}) {
    const bannerSize = {
        [LARGE]: 'p-4 text-p14',
        [SMALL]: 'p-2 text-p12'
    };

    const notificationBannerType = {
        [BANNER_INFO]: {
            Icon: InfoIcon,
            iconColor: BLUE_KEY,
            iconSize: M_KEY,
            cssClass: `bg-bmStatus-info-muted text-bmStatus-info ${bannerSize[size]}`
        },
        [BANNER]: {
            Icon: RulerIcon,
            iconColor: BLACK_KEY,
            iconSize: M_KEY,
            cssClass: `bg-bmBg-muted text-bmText-default ${bannerSize[size]}`
        }
    };

    const {
        cssClass,
        Icon: defaultIcon,
        iconColor,
        iconSize: defaultSize
    } = notificationBannerType[type];

    const IconComponent = icon || defaultIcon;

    return (
        <div className={ `flex items-center gap-3 ${ cssClass }` }>
            { !isHideIcon && (
                <div>
                    <IconComponent color={ iconColor } size={ iconSize || defaultSize } />
                </div>
            ) }
            <p className="text-inherit">
                { text || children }
            </p>
        </div>
    );
}
NoticeBanner.propTypes = {
    icon: PropTypes.elementType,
    text: PropTypes.string,
    type: PropTypes.oneOf([BANNER_INFO, BANNER]),
    size: PropTypes.string,
    iconSize: PropTypes.string,
    children: PropTypes.node,
    isHideIcon: PropTypes.bool
};
NoticeBanner.defaultProps = {
    icon: null,
    text: '',
    type: BANNER_INFO,
    size: SMALL,
    iconSize: null,
    children: null,
    isHideIcon: false
};

export default NoticeBanner;
